import React, { Component } from 'react';
import SignInComponent from '../components/SignInComponent';
export default class Signin extends Component {
  render() {
    return (
      <SignInComponent/>
    );
  }
}
